export const STORYDOC_PREFIX = "storydoc:";
export const STORYDOC_AVATAR =
  "https://assets.storydoc.com/assets/images/comments/storydoc-avatar.svg";
export const UNKNOWN_AVATAR =
  "https://assets.storydoc.com/assets/images/comments/unknown-avatar.svg";
